<template>
  <div class="time-range-picker">
    <el-form ref="formRef" size="small" inline label-width="0">
      <div v-for="(item, index) in timeRanges" :key="index" class="time-range-item">
        <div class="item-container">
          <el-time-select
            v-model="item.start"
            size="mini"
            :placeholder="$t('text.kssj')"
            :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '24:00',
              maxTime: item.end
            }"
            @change="handleChange"
          />
          <div class="range-separator">至</div>
          <el-time-select
            v-model="item.end"
            size="mini"
            :placeholder="$t('text.jssj')"
            :picker-options="{
              start: '01:00',
              step: '01:00',
              end: '24:00',
              minTime: item.start
            }"
            @change="handleChange"
          />
          <el-button
            type="text"
            icon="el-icon-delete"
            class="button-remove"
            size="small"
            @click="handleRemoveItem(index)"
          />
        </div>
      </div>
    </el-form>
    <el-button type="text" icon="el-icon-plus" class="button-add" size="small" @click="handleAddItem">添加{{ timeRangeName }}时段</el-button>
  </div>
</template>

<script>
export default {
  name: 'TimeRangePicker',
  model: {
    prop: 'value',
    event: 'updateValue'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },

    /** 时间范围名称(尖峰平谷深谷) */
    timeRangeName: {
      required: true,
      type: String,
      default: ''
    }
  },
  data () {
    return {
      timeRanges: []
    }
  },
  mounted () {
    this.setFormValue(this.value)
  },
  methods: {

    /** 添加单个时段 */
    handleAddItem () {
      this.timeRanges.push({ start: '', end: '' })
      this.$emit('updateValue', this.timeRanges)
    },

    /** 移除单个时段 */
    handleRemoveItem (index) {
      this.timeRanges.splice(index, 1)
      this.$emit('updateValue', this.timeRanges)
    },

    /** 时间选择器改变时触发 */
    handleChange () {
      this.$emit('updateValue', this.timeRanges)
    },

    /** 设置表单值 */
    setFormValue (value) {
      this.timeRanges = JSON.parse(JSON.stringify(value))
    }
  }
}
</script>

<style scoped>
.time-range-picker {
  width: 100%;
}

.time-range-item {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.time-range-item .item-container {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 30px 1fr 20px;
}

.time-range-item .item-container .range-separator {
  margin: 0 8px;
  color: var(--primary-color);
}

.time-range-item .item-container .el-button {
  margin-left: 8px;
  padding: 0;
}

.button-add,
.button-add:hover,
.button-add:active,
.button-add.el-button--text:focus,
.button-add.el-button--text:hover{
  color: var(--primary-color);
}
.button-remove,
.button-remove:hover,
.button-remove:active,
.button-remove.el-button--text:focus,
.button-remove.el-button--text:hover{
  color: var(--danger-color);
}

</style>
<style>
.time-select-item{
  transition: background-color 0.1s ease-out;
}
.time-select-item:hover{
  background-color: cadetblue;
}
</style>
